import React from "react";
import {
  CompanySection,
  ProductsSection,
  GrowthSection,
  TeamSection,
  AchievementsSection,
  PressSection,
  CultureSection,
  CareersCTA,
} from "../../components";

const Home = () => {
  return (
    <>
      <CompanySection />
      <ProductsSection />
      <GrowthSection />
      <TeamSection />
      <AchievementsSection />
      <PressSection />
      <CultureSection />
      <CareersCTA />
    </>
  );
};

export default Home;
